<template>
  <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="date"
          label="Day of origin"
          prepend-icon="mdi-calendar"
          readonly
          hide-details
          flat
          outlined
          dense
          v-bind="attrs"
          v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        no-title
        scrollable
        :max="maxDate"
        @input="menu = false"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  name: 'FlightDatePicker',
  props: {
    value: {
      type: String,
      required: true
    },
    now :{
      type: Date,
      required: true
    }
  },
  data: () => ({
    menu: false,
  }),
  components: {
  },
  methods: {
  },
  computed: {
    date: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    maxDate () {
      return moment(this.now).utc().add(1, 'days').format('yyyy-MM-DD')
    }
  }
}
</script>
